import { render } from "./Checkout.vue?vue&type=template&id=52ac37c8"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=52ac37c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__